import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import styled from "@emotion/styled";
import BaseButton from "src/atoms/Button/BaseButton";
import { CloseButton } from "src/atoms/CloseButton";

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-left: -${({ theme }) => theme.space[1]}px;
  margin-bottom: -${({ theme }) => theme.space[1]}px;
  margin-top: ${({ theme }) => theme.space[2]}px;
  > div {
    margin: ${({ theme }) => theme.space[1]}px;
  }
`;

const StyledText = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  font-weight: 600;
  margin-right: ${({ theme }) => theme.space[1]}px;
  line-height: 1.71;
  color: ${({ theme }) => theme.colors.tone.anthraciteDark};
`;

const StyledCloseButton = styled(CloseButton)`
  margin-right: ${({ theme }) => theme.space[2]}px;
  padding: 0;
  width: 14px;
  path {
    stroke: ${({ theme }) => theme.colors.tone.anthraciteLight};
    stroke-width: 2;
  }
  &:hover {
    path {
      stroke: ${({ theme }) => theme.colors.tone.anthraciteDark};
    }
  }
`;

const ColorBox = styled.div<{ hex?: string; icon?: string; id: string }>`
  width: 14px;
  height: 14px;
  border-radius: 2px;
  margin-right: ${({ theme }) => theme.space[1]}px;
  ${({ id, theme }) =>
    id === "WHITE" &&
    `
  border: 1px solid;
  border-color: ${theme.colors.tone.anthraciteLight};
  `}
  ${({ hex, icon }) =>
    !hex &&
    icon &&
    `
    background-position: center;
    background-size: 30px;
    background-image: url(${icon});
  `}
  ${({ hex }) => hex && `background-color: ${hex};`}
`;

const Button = styled(BaseButton)`
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding-left: 1px;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  line-height: 1.43;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  &:hover {
    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  }
`;

export { Wrapper, StyledCloseButton, Button, StyledText, ColorBox };
